<template>
    <div class="quotation">
        <home-nav></home-nav>

        <div class="mice_banner">
            <div class="jmkt-picsroller123">
                <img src="../../assets/images/travel/banner.png" alt="">
            </div>

            <div class="messageForm">
                <div class="input-tit">
                    定制旅行
                    <span class="small-tit">
                        1对1定制服务，方案可沟通调整
                    </span>
                </div>
                <ul class="travel-type">
                    <li class="type-name" :class="curNum == 0 ? 'active' : ''" @click="typeChange(0)">
                        个人/家庭定制
                    </li>
                    <li class="type-name" :class="curNum == 1 ? 'active' : ''" @click="typeChange(1)">
                        企业/团建定制
                    </li>
                </ul>
                <ul class="input-area">
                    <li class="choose-city">
                        <span class="grey-tip">
                            出发
                        </span>
                        <!--<input type="text" class="dep-city" readonly v-model="startCity">-->
                        <el-cascader
                                class="dep-city"
                                size="small"
                                :options="options"
                                v-model="startCity"
                                @change="handleChangeT"
                                :value="addressInfo"
                        >
                        </el-cascader>
                        <span class="city-icon djicon djicon-arrow-pc-dz">
                            →
                        </span>
                        <span class="grey-tip">目的地</span>
                        <input type="text" class="dest-city" readonly v-model="endCity"
                               @click="showCityBoxBtn()">

                        <div v-show="showCityBox">
                            <div class="dest-city-wrap city-wrap">
                                <div class="main-city-wrap">
                                    <div class="first-catalog">
                                        <div class="closeImg" @click="closeCity()">
                                            <img class="closeImgIcon" src="@/assets/images/travel/round_close.png"
                                                 alt="">
                                        </div>

                                        <div class="city-nav" :class="curClick == 0 ? 'active' : ''"
                                             @click="curclickBtn(0)">热门
                                        </div>
                                        <div class="city-nav" :class="curClick == 1 ? 'active' : ''"
                                             @click="curclickBtn(1)">周边
                                        </div>
                                        <div class="city-nav" :class="curClick == 2 ? 'active' : ''"
                                             @click="curclickBtn(2)">境内
                                        </div>
                                    </div>

                                    <div class="citylist-wrap">
                                        <div class="selectcity-list" v-show="curClick == 0">
                                            <div class="letter-name">
                                                境内热门
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in hotCity" :key="index"
                                                     @click="hotCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selectcity-list" v-show="curClick == 1">
                                            <div class="letter-name">
                                                热门目的地
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in nearCity" :key="index"
                                                     @click="nearCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selectcity-list" v-show="curClick == 1">
                                            <div class="letter-name">
                                                江苏
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in jiangsuCity" :key="index"
                                                     @click="jiangsuCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selectcity-list" v-show="curClick == 1">
                                            <div class="letter-name">
                                                浙江
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in zhejiangCity" :key="index"
                                                     @click="zhejiangCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selectcity-list" v-show="curClick == 1">
                                            <div class="letter-name">
                                                上海
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in shanghaiCity" :key="index"
                                                     @click="shanghaiCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selectcity-list" v-show="curClick == 2">
                                            <div class="letter-name">
                                                热门目的地
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in hotInCity" :key="index"
                                                     @click="hotInCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="selectcity-list" v-show="curClick == 2">
                                            <div class="letter-name">
                                                安徽
                                            </div>
                                            <div class="current-citylist">
                                                <div class="city-item" :class="{'active':spanIndex.indexOf(item.id)>-1}"
                                                     v-for="(item,index) in hotInAnHuiCity" :key="index"
                                                     @click="hotInAnHuiCityClick(item)">
                                                    {{ item.text }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="choose-date">
                        <span class="grey-tip">
                            出游日期
                        </span>
                        <!--<span class="play-date J-Calendar"></span>-->
                        <el-date-picker
                                class="zidinyi"
                                v-model="timeStart"
                                type="date"
                                placeholder=""
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </li>

                    <li class="choose-more">
                        <!-- <div class="people">
                          <input type="number" name="" id="" value="" placeholder="人数" />
                        </div> -->
                        <span class="grey-tip">
                            人数
                        </span>
                        <input type="text" v-model="personNum">
                    </li>

                    <li class="choose-phone">
                        <span class="grey-tip">
                            手机号
                        </span>
                        <input type="text" maxlength="11" v-model="formTelephone"/>
                    </li>
                </ul>

                <div class="book-icon" @click="submitPost()">
                    即刻获取 达人定制方案
                </div>
            </div>
        </div>

        <div class="mice_processline">
            <div class="mice_layout">
                <dl class="process_line cf">
                    <dt>
                        <img src="@/assets/images/travel/process_ico1.png" alt="">
                        <p class="tit">快速提交需求单</p>
                    </dt>
                    <dd>
                        <img src="@/assets/images/travel/process_arr1.png" alt="">
                    </dd>
                    <dt>
                        <img src="@/assets/images/travel/process_ico2.png" alt="">
                        <p class="tit">免费发送方案</p>
                    </dt>
                    <dd>
                        <img src="@/assets/images/travel/process_arr1.png" alt="">
                    </dd>
                    <dt>
                        <img src="@/assets/images/travel/process_ico3.png" alt="">
                        <p class="tit">沟通确认行程</p>
                    </dt>
                    <dd>
                        <img src="@/assets/images/travel/process_arr1.png" alt="">
                    </dd>
                    <dt>
                        <img src="@/assets/images/travel/process_ico4.png" alt="">
                        <p class="tit">签约合同欢乐出行</p>
                    </dt>
                </dl>

                <!-- <div class="process_r">
                    <a href="javascript: void(0);" class="btn_link">
                        立即定制
                    </a>
                </div> -->
            </div>

            <div class="no_worry_mod">
                <img class="pic" src="@/assets/images/travel/fxy.png" alt="">
                <span class="text">付款后承诺不加价·更改则赔付</span>
                <a class="link" @click="showBz()">更多保障</a>
            </div>

            <div class="mice_cons">
                <div class="mice_layout_con">
                    <ul class="mice_tab_btn cf">
                        <li :class="tabOne == 1 ? 'on' : ''" @click="tabLiClick(1)">个人定制</li>
                        <li :class="tabOne == 2 ? 'on' : ''" @click="tabLiClick(2)">团建/公司定制</li>
                    </ul>
                    <div class="mice_box" v-show="tabOne == 1">
                        <div class="mice_box_hd has_tabs">
                            <p class="hd_text">
                                <em class="tit">当季热门</em>
                                <span class="tit_sub">
                                    没有旅行灵感？看看定制师制作的案例吧
                                </span>
                            </p>
                            <ul class="tabs_list cf">
                                <li :class="proNum == index ? 'on' : ''" v-for="(item,index) in proList" :key="index"
                                    @click="proClick(index)">
                                    <a href="javascript: void(0);">
                                        {{ item.pro }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="mice_list_i cf">
                            <a href="javascript: void(0);" v-for="(item,index) in dataProList" :key="index"
                               @click="todetail(index,item.id)">
                                <div class="pic">
                                    <img :src="item.rotation" alt="">
                                </div>
                                <em class="days">
                                    {{ item.travel_days }}天
                                </em>
                                <div class="mask_box cf">
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            {{ item.per_price }}
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>
                                </div>
                                <div class="txtinfo">
                                    <h3 class="subtit" :title="item.title">
                                        {{ item.title }}
                                    </h3>
                                    <p class="subtips">
                                        <span v-for="(single,index) in item.signal" :key="index">
                                            {{ single }}
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="mice_box" v-show="tabOne == 1">
                        <div class="mice_box_hd has_tabs">
                            <p class="hd_text">
                                <em class="tit">世界这么大</em>
                                <span class="tit_sub">
                                    谁说旅行千篇一律？定制属于自己的旅程
                                </span>
                            </p>
                            <!--<ul class="tabs_list cf">
                                <li :class="jingdianNum == index ? 'on' : ''" v-for="(item,index) in jingdianList"
                                    :key="index" @click="jingdianClick(index)">
                                    <a href="javascript: void(0);">
                                        {{ item.text }}
                                    </a>
                                </li>
                            </ul>-->
                        </div>

                        <ul class="mice_list_ii cf">
                            <li :class="index == 0 ? 'big_item' : ''" v-for="(item,index) in typeDataList" :key="index"
                                @click="todetail(item.id)">
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img :src="item.rotation" alt="">
                                    </div>
                                    <em class="days">
                                        {{ item.travel_days }}天
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            {{ item.per_price }}
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>
                                    <h3 class="subtit" :title="item.title">
                                        {{ item.title }}
                                    </h3>
                                    <p class="subtips">

                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <!--暂时不显示-->
                    <div class="mice_box" v-show="tabOne == 3">
                        <div class="mice_box_hd has_tabs">
                            <p class="hd_text">
                                <em class="tit">
                                    案例分享
                                </em>
                                <span class="tit_sub">
                                    公司定制经典案例
                                </span>
                            </p>
                            <ul class="tabs_list cf">
                                <li :class="tjListNum == index ? 'on' : ''" v-for="(item,index) in tjList" :key="index"
                                    @click="tjClick(index)">
                                    <a href="javascript: void(0);">
                                        {{ item.text }}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <ul class="mice_list_ii cf">
                            <li :class="index == 0 ? 'big_item' : ''" @click="todetail(item.id)"
                                v-for="(item,index) in tjDataList" :key="index">
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img :src="item.img" alt="">
                                    </div>
                                    <em class="days">
                                        {{ item.day }}天
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            {{ item.money }}
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>
                                    <h3 class="subtit" :title="item.title">
                                        {{ item.title }}
                                    </h3>
                                    <p class="subtips">

                                    </p>
                                </a>
                            </li>

                            <!--<li>
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img src="@/assets/images/travel/ms02.png" alt="">
                                    </div>
                                    <em class="days">
                                        5天
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            3500
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>
                                    <h3 class="subtit" title="5日成都+乐山+峨眉山·家庭亲子+品成都美味+感受川蜀文化">
                                        5日成都+乐山+峨眉山·家庭亲子+品成都美味+感受川蜀文化
                                    </h3>
                                    <p class="subtips">

                                    </p>
                                </a>
                            </li>

                            <li>
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img src="@/assets/images/travel/ms03.png" alt="">
                                    </div>
                                    <em class="days">
                                        5天
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            2690
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>
                                    <h3 class="subtit" title="5日桂林+灵川+阳朔·赏龙脊梯田+打卡网红银子岩+山水实景印象刘三姐">
                                        5日桂林+灵川+阳朔·赏龙脊梯田+打卡网红银子岩+山水实景印象刘三姐
                                    </h3>
                                    <p class="subtips">

                                    </p>
                                </a>
                            </li>-->
                        </ul>
                    </div>

                    <!--暂时不显示-->
                    <div class="mice_box" v-show="tabOne == 3">
                        <div class="mice_box_hd has_btns">
                            <p class="hd_text">
                                <em class="tit">
                                    我们的客户
                                </em>
                                <span class="tit_sub">
                                    看看出发的人怎么说
                                </span>
                            </p>
                        </div>

                        <div class="mice_list_ii kh_mice_list_li cf">
                            <li>
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img src="//pic.c-ctrip.com/VacationOnlinePic/mice_v3/qy_pic01.jpg" alt="">
                                    </div>
                                    <em class="days">
                                        企业旅行
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            2690
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>

                                    <div class="r_info">
                                        <dl class="r_info_text">
                                            <dl class="r_info_text">
                                                <dt>
                                                    昆山若泰建筑装饰工程有限公司昆山-桂林之旅
                                                </dt>
                                                <dd>
                                                    <span class="ltit">
                                                        天数：
                                                    </span>
                                                    <p class="rtxt">
                                                        4天
                                                    </p>
                                                </dd>
                                                <dd>
                                                    <span class="ltit">
                                                        评价：
                                                    </span>
                                                    <p class="rtxt">
                                                        行程安排的很丰富，导游很有素养，很靠谱
                                                    </p>
                                                </dd>
                                            </dl>

                                            <span class="btn_fast">
                                                快速定制
                                            </span>
                                        </dl>
                                    </div>
                                </a>
                            </li>

                            <li>
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img src="//pic.c-ctrip.com/VacationOnlinePic/mice_v3/qy_pic01.jpg" alt="">
                                    </div>
                                    <em class="days">
                                        企业旅行
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            2690
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>

                                    <div class="r_info">
                                        <dl class="r_info_text">
                                            <dl class="r_info_text">
                                                <dt>
                                                    昆山若泰建筑装饰工程有限公司昆山-桂林之旅
                                                </dt>
                                                <dd>
                                                    <span class="ltit">
                                                        天数：
                                                    </span>
                                                    <p class="rtxt">
                                                        4天
                                                    </p>
                                                </dd>
                                                <dd>
                                                    <span class="ltit">
                                                        评价：
                                                    </span>
                                                    <p class="rtxt">
                                                        行程安排的很丰富，导游很有素养，很靠谱
                                                    </p>
                                                </dd>
                                            </dl>

                                            <span class="btn_fast">
                                                快速定制
                                            </span>
                                        </dl>
                                    </div>
                                </a>
                            </li>

                            <li>
                                <a href="javascript: void(0);">
                                    <div class="pic">
                                        <img src="//pic.c-ctrip.com/VacationOnlinePic/mice_v3/qy_pic01.jpg" alt="">
                                    </div>
                                    <em class="days">
                                        企业旅行
                                    </em>
                                    <i class="mask_box">

                                    </i>
                                    <p class="price">
                                        <dfn>¥</dfn>
                                        <span class="num">
                                            2690
                                        </span>
                                        <span class="txt">
                                            /人起
                                        </span>
                                    </p>

                                    <div class="r_info">
                                        <dl class="r_info_text">
                                            <dl class="r_info_text">
                                                <dt>
                                                    昆山若泰建筑装饰工程有限公司昆山-桂林之旅
                                                </dt>
                                                <dd>
                                                    <span class="ltit">
                                                        天数：
                                                    </span>
                                                    <p class="rtxt">
                                                        4天
                                                    </p>
                                                </dd>
                                                <dd>
                                                    <span class="ltit">
                                                        评价：
                                                    </span>
                                                    <p class="rtxt">
                                                        行程安排的很丰富，导游很有素养，很靠谱
                                                    </p>
                                                </dd>
                                            </dl>

                                            <span class="btn_fast">
                                                快速定制
                                            </span>
                                        </dl>
                                    </div>
                                </a>
                            </li>
                        </div>
                    </div>

                    <div class="mice_box">
                        <div class="mice_box_hd">
                            <p class="hd_text">
                                <em class="tit">
                                    热门定制师
                                </em>
                                <span class="tit_sub">
                                    案例太多不知所措?专业定制师帮你选
                                </span>
                            </p>
                        </div>

                        <div class="mice_dzer_list">
                            <div class="swiper-container">
                                <swiper class="swiper-wrapper" ref="mySwiper" :options="swiperOptions">
                                    <swiper-slide
                                            class="swiper-slide"
                                            v-for="(item,idx) in 3"
                                            :key="item">

                                        <div class="swiper-slide-list" v-for="(itemIn,idxIn) in 3"
                                             @mouseenter="showCon(idxIn)" @mouseleave="hideCon(idxIn)">
                                            <a href="javascript:;">
                                                <div class="pic">
                                                    <img src="https://dimg04.c-ctrip.com/images/0302p12000842y7jp7E44.jpg"
                                                         alt="">
                                                    <div class="text_frame" v-show="showNum == idxIn ? 'hoveShow' : ''">
                                                        01人生就像一场旅行，不必在乎目的地，在意的是沿途的风景和心情，让心灵去旅行
                                                    </div>
                                                </div>

                                                <div class="info">
                                                    <dt>
                                                        十佳定制师先雪丹
                                                    </dt>
                                                    <dd>
                                                        擅长：四川
                                                    </dd>
                                                </div>
                                            </a>
                                        </div>

                                    </swiper-slide>
                                    <div class="swiper-pagination" slot="pagination"></div>
                                </swiper>

                                <!-- <div class="swiper-button-prev"></div>
                                <div class="swiper-button-next"></div> -->
                            </div>

                        </div>
                    </div>

                    <div class="mice_box">
                        <div class="mice_box_hd">
                            <p class="hd_text">
                                <em class="tit">
                                    我们将提供什么？
                                </em>
                            </p>
                        </div>

                        <ul class="mice_list_iii cf">
                            <li v-for="(item,index) in giveList" :key="index">
                                <div class="pic">
                                    <img :src="item.img" alt="">
                                </div>
                                <p class="text1">
                                    {{ item.text1 }}
                                </p>
                                <p class="text2">
                                    {{ item.text2 }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!--底部-->
        <home-footer></home-footer>

        <!--右侧列表-->
        <div class="mice_side">
            <div class="item" @click="toTop()">
                <img src="@/assets/images/travel/side3.png" alt="">
                <p class="text">
                    回到<br>顶部
                </p>
            </div>

            <div class="item" @mouseenter="showWhatChat()" @mouseleave="hideWhatChat()">
                <img src="@/assets/images/travel/side4.png" alt="">
                <p class="text">
                    微信<br>添加
                </p>

                <div class="pop_show" v-show="showWx">
                    <div class="pic">
                        <img src="@/assets/images/travel/erweima.png" alt="">
                    </div>
                    <p class="text1">
                        扫码添加微信
                    </p>
                    <i class="arr">

                    </i>
                </div>
            </div>
        </div>

        <!--服务保障-弹窗内筒-->
        <div class="mask_bg" v-show="showBox"></div>
        <div class="resource_mask no_worry_mask" v-show="showBox">
            <a class="close" @click="closeBox()">
                <span>关闭</span>
            </a>
            <div class="no_worry_mask_content mask_content">
                <h4 class="title_mod">
                    放心游服务保障
                </h4>

                <div class="scroll_mod">
                    <div class="no_worry_text_cont">
                        <ul class="no_worry_list">
                            <li>
                                <h4 class="text_title text1">

                                </h4>
                                <div class="text_main">
                                    <p class="text_para">
                                        订单付款后，定制师不得因自身原因及第三方要求擅自加价（领馆原因除外），如定制师违规，定制师需要为您承担相应差价或按合同规定进行赔付
                                    </p>
                                </div>
                            </li>

                            <li>
                                <h4 class="text_title text2">

                                </h4>
                                <div class="text_main">
                                    <p class="text_para">
                                        订单付款后，如未经您同意，因定制师原因更改订单（不可抗因素除外），定制师需要向您进行赔付。如您接受降价更改，差价退一赔一；如您不接受更改或取消，则按合同取消进行赔付
                                    </p>
                                </div>
                            </li>

                            <li>
                                <h4 class="text_title text3">

                                </h4>
                                <div class="text_main">
                                    <p class="text_para">
                                        为了分担旅游客户因为自身不能预期和控制的特殊原因退订产生的损失，设立“特殊原因退订保障”
                                        如果您满足下述公示条件，请最晚于出行日前联系我司申请，并在提出申请后七天内交齐材料（如因特殊情况材料无法按期提供，请您予以告知）。我司将补贴给您：订单最终实际损失（订单最终实际损失=订单实际损失-保险可理赔金额；已生效的保险费用及已送签并已产生的签证可选项费用不算入订单实际损失）
                                    </p>
                                    <div class="table_mod">
                                        <table class="no_worry_table">
                                            <colgroup>
                                                <col class="width01">
                                                <col class="width02">
                                                <col class="width03">
                                                <col class="width04">
                                                <col class="width05">
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th>状况当事人</th>
                                                <th colspan="3">
                                                    出行人本人及其子女、配偶、父母（含岳父母、公婆）
                                                </th>
                                                <th>
                                                    出行人本人
                                                </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            <tr>
                                                <th>
                                                    突发情况
                                                </th>
                                                <th>
                                                    身故
                                                </th>
                                                <th>
                                                    住院
                                                </th>
                                                <th>
                                                    骨折
                                                </th>
                                                <th>
                                                    怀孕
                                                </th>
                                            </tr>

                                            <tr>
                                                <th>
                                                    特殊原因退订受益人
                                                </th>
                                                <td colspan="3">
                                                    订单内本人及同行子女、配偶、父母（含岳父母、公婆）
                                                </td>
                                                <td>
                                                    本人及同行子女、配偶
                                                </td>
                                            </tr>

                                            <tr>
                                                <th>
                                                    材料及说明
                                                </th>
                                                <td>
                                                    死亡证明、户口本等关系证明材料
                                                </td>
                                                <td colspan="3">
                                                    出具三级甲等医院病历/诊断书、包含“不宜出行”字样的病假单、住院证明（住院期间须与出行期间重叠）和收费证明 特别说明：
                                                    1.仅保障因突发急性病的住院。（【突发急性病】指在本次产品预订后出行日期前突然发生的、在突发前未曾接受治疗或诊断的（首次罹患的突发性疾病或出现的）、必须立即接受治疗方能避免身体或生命伤害的疾病，不包括既往疾病、慢性病、精神病、
                                                    精神分裂、艾滋病、性传播疾病、遗传性疾病、先天性疾病或缺陷、先天性畸形、牙齿治疗、预防性手术、非必须紧急治疗的手术或器官移植、因脊椎间盘突出症或错位的治疗、脑梗、心梗等。）
                                                    2.若病历/诊断书/病假单上证明病情/怀孕日期在产品预订日期之前则不做保障。 3.当地若无三级甲等医院的以当地最高级别医院诊断为准。
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="text_para">
                                        补充说明：<br>
                                        1.逾期未联系我司提交申请并按要求递交保障所需材料的视为自行放弃，我们有权不予保障<br>
                                        2.特殊原因退订所需申请材料当事人需保证材料真实有效，若提供材料存在真实性等问题，我司有权不予保障，并有权收回已发放的保障
                                        3.受理条件以受理当日公示的受理条件为准，我司保留在适当时候修订受理条件而不另外通知的权利
                                    </div>
                                </div>
                            </li>

                            <li>
                                <h4 class="text_title text4">

                                </h4>
                                <div class="text_main">
                                    <p class="text_para">
                                        我司旅游客人如果遇到不可预测的自然灾害（政府官方机构发布橙色或红色预警级别）、政治或社会卫生事件（政府官方机构发布暂勿或禁止前往预警）造成旅游体验受实质损害的，我司将视具体情况启动重大灾害旅游体验保障金，对行程受直接影响而取消所产生的订单最终实际损失予以承担（订单最终实际损失=订单实际损失—保险可理赔金额），对游客滞留期间产生的必要新增费用进行相应补贴（旅行滞留住宿补贴金为300元/间/夜，若我司已额外承担或垫付的则不再额外赠予）
                                    </p>
                                </div>
                            </li>

                            <li>
                                <h4 class="text_title text5">

                                </h4>
                                <div class="text_main">
                                    <p class="text_para">
                                        在业内率先建立旅游预警机制，在自然灾害、病疫灾害、政治变动、突发事件等情况下，及时联系即将出行及处于行程中的客人，提醒其注意风险，从而保障客人安全和权益
                                    </p>
                                </div>
                            </li>

                            <li>
                                <h4 class="text_title text6">

                                </h4>
                                <div class="text_main">
                                    <p class="text_para">
                                        在旅途中，无论遇到行李或证件遗失，还是误机、误车，抑或受伤或生病等紧急突发情况，致电我司，您第一时间均可得到我们工作人员的及时响应及积极协助，包括：行李遗失找回后的境内外带回服务、证件遗失后的“指导补办”服务、误机误车15分钟响应处置服务、送医就诊协助及翻译服务等。如遇到意外事故导致旅行难以为继，客人也将得到我们力所能及的必要援助
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';
    import {mapGetters} from 'vuex';

    export default {
        name: "travel",
        components: {
            homeNav,
            homeFooter
        },
        data() {
            return {
                addressInfo: '',
                options: [],
                startCity: '',
                endCity: '',
                showCityBox: false,
                spanIndex: [],
                spanText: [],
                itemList: '',
                timeStart: new Date(),
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    }
                },
                personNum: '',
                formTelephone: '',
                curClick: 0,
                hotCity: [
                    {
                        text: '厦门',
                        id: 'xiamen'
                    },
                    {
                        text: '福州',
                        id: 'fuzhou'
                    },
                    {
                        text: '北京',
                        id: 'beijing'
                    },
                    {
                        text: '大理',
                        id: 'dali'
                    },
                    {
                        text: '桂林',
                        id: 'guilin'
                    },
                    {
                        text: '成都',
                        id: 'chengdu'
                    },
                    {
                        text: '重庆',
                        id: 'chongqing'
                    },
                    {
                        text: '杭州',
                        id: 'hangzhou'
                    },
                    {
                        text: '苏州',
                        id: 'suzhou'
                    },
                ],

                hotCityNum: -1,

                nearCity: [
                    {
                        text: '厦门',
                        id: 'xiamen'
                    },
                    {
                        text: '泉州',
                        id: 'quanzhou'
                    },
                    {
                        text: '漳州',
                        id: 'zhangzhou'
                    },
                    {
                        text: '福州',
                        id: 'fuzhou'
                    },
                    {
                        text: '武夷山',
                        id: 'wuyishan'
                    },
                    {
                        text: '鼓浪屿',
                        id: 'gulanyu'
                    },
                ],

                nearCityNum: -1,

                jiangsuCity: [
                    {
                        text: '无锡',
                        id: 'wuxi'
                    },
                    {
                        text: '南京',
                        id: 'nanjing'
                    },
                    {
                        text: '苏州',
                        id: 'suzhou'
                    },
                    {
                        text: '泰州',
                        id: 'taizhou'
                    },
                    {
                        text: '常州',
                        id: 'changzhou'
                    },
                    {
                        text: '镇江',
                        id: 'zhenjiang'
                    },
                    {
                        text: '汤山',
                        id: 'tangshan'
                    },
                    {
                        text: '阳澄湖',
                        id: 'yangchenghu'
                    },
                    {
                        text: '周庄',
                        id: 'zhouzhuang'
                    },
                    {
                        text: '扬州',
                        id: 'yangzhou'
                    },
                    {
                        text: '连云港',
                        id: 'lianyungang'
                    },
                    {
                        text: '南通',
                        id: 'nantong'
                    },
                ],

                jiangsuCityNum: -1,

                zhejiangCity: [
                    {
                        text: '安吉',
                        id: 'anji'
                    },
                    {
                        text: '大明山',
                        id: 'damingshan'
                    },
                    {
                        text: '宁波',
                        id: 'ningbo'
                    },
                    {
                        text: '临安',
                        id: 'linan'
                    },
                    {
                        text: '绍兴',
                        id: 'shaoxing'
                    },
                    {
                        text: '杭州',
                        id: 'hangzhou'
                    },
                    {
                        text: '西塘',
                        id: 'xitang'
                    },
                    {
                        text: '舟山',
                        id: 'zhoushan'
                    },
                    {
                        text: '南普陀',
                        id: 'nanputuo'
                    },
                    {
                        text: '海宁',
                        id: 'haining'
                    },
                    {
                        text: '桐庐',
                        id: 'tonglu'
                    },
                    {
                        text: '建德',
                        id: 'jiande'
                    },
                    {
                        text: '台州',
                        id: 'taizhou'
                    },
                    {
                        text: '象山',
                        id: 'xiangshan'
                    },
                    {
                        text: '横店',
                        id: 'hengdian'
                    },
                ],

                zhejiangCityNum: -1,

                shanghaiCity: [
                    {
                        text: '崇明',
                        id: 'chongming'
                    },
                ],

                shanghaiCityNum: -1,

                hotInCity: [
                    {
                        text: '厦门',
                        id: 'xiamen'
                    },
                    {
                        text: '泉州',
                        id: 'quanzhou'
                    },
                    {
                        text: '福州',
                        id: 'fuzhou'
                    },
                    {
                        text: '武夷山',
                        id: 'wuyishan'
                    },
                    {
                        text: '杭州',
                        id: 'hanghzou'
                    },
                    {
                        text: '三亚',
                        id: 'sanya'
                    },
                    {
                        text: '大理',
                        id: 'dali'
                    },
                    {
                        text: '广州',
                        id: 'guangzhou'
                    },
                ],

                hotInCityNum: -1,

                hotInAnHuiCity: [
                    {
                        text: '黄山',
                        id: 'huangshan'
                    },
                    {
                        text: '滁州',
                        id: 'chuzhou'
                    },
                    {
                        text: '合肥',
                        id: 'hefei'
                    },
                    {
                        text: '六安',
                        id: 'luan'
                    },
                    {
                        text: '芜湖',
                        id: 'wuhu'
                    },
                    {
                        text: '九华山',
                        id: 'jiuhuashan'
                    },
                ],

                hotInAnHuiCityNum: -1,

                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination',    //与slot="pagination"处 class 一致
                        clickable: true,            //轮播按钮支持点击
                        navigation: {
                            prevEl: '.swiper-button-prev',
                            nextEl: ".swiper-button-next",
                        }
                    }
                },
                showBox: false,
                curNum: 0,
                tabOne: 1,
                proList: [
                    {
                        pro: '福建省内线路'
                    },
                    {
                        pro: '福建跨省线路'
                    },
                    /* {
                        pro: '海南'
                    },
                    {
                        pro: '陕西'
                    },
                    {
                        pro: '湖南'
                    }, */
                ],
                proNum: 0,
                dataProList: [],
                dataOneList: [
                    {
                        rotation: require('@/assets/images/travel/xm.png'),
                        day: 5,
                        per_price: 3500,
                        title: '5日-成都+乐山+峨眉山·行愿峨眉山+船游乐山大佛',
                        content: '品成都文化，船游乐山大佛'
                    },
                    {
                        rotation: require('@/assets/images/travel/jingdian02.png'),
                        day: 2,
                        per_price: 368,
                        title: '2日-康定+甘孜+成都·墨石公园+塔公草原+雅拉雪山+木雅圣地+折多山+新都桥',
                        content: '中国地质百慕大墨石公园'
                    },
                    {
                        rotation: require('@/assets/images/travel/jingdian03.png'),
                        day: 5,
                        per_price: 1280,
                        title: '5日-成都+广汉+都江堰+重庆·品成都文化+拜水都江堰+问道青城山+萌宝大熊猫+参观三星堆博物馆',
                        content: '品川渝文化，感受慢生活'
                    },
                    {
                        rotation: require('@/assets/images/travel/jingdian04.png'),
                        day: 8,
                        per_price: 3888,
                        title: '8日成都+康定+稻城+都江堰+九寨沟·稻城亚丁+勒通古镇+长青春科尔寺+墨石公园+新都桥+九寨沟黄龙',
                        content: '稻城亚丁九寨沟玩出新花样'
                    },
                ],

                dataTwoList: [
                    {
                        rotation: require('@/assets/images/travel/yunnan01.png'),
                        day: 6,
                        per_price: 2300,
                        title: '6日丽江+大理+香格里拉·敞篷吉普车环游洱海+探访神秘女儿国+篝火晚会',
                        content: '苍山洱海+玉龙雪山+古城'
                    },
                    {
                        rotation: require('@/assets/images/travel/yunnan02.png'),
                        day: 5,
                        per_price: 2480,
                        title: '5日西双版纳·傣乡雨林探秘+观大象表演孔雀放飞',
                        content: '探秘雨林，做客动植物王国'
                    },
                    {
                        rotation: require('@/assets/images/travel/yunnan03.png'),
                        day: 5,
                        per_price: 1880,
                        title: '5日丽江+大理·蜜月之旅+夜宿双廊海景房+观巍峨玉龙雪山',
                        content: '大理海景客栈'
                    },
                    {
                        rotation: require('@/assets/images/travel/yunnan04.png'),
                        day: 6,
                        per_price: 2180,
                        title: '6日大理+丽江+香格里拉·洱海旅拍+登顶雪山+探索世外桃源',
                        content: '温馨亲子游'
                    },
                ],

                dataThreeList: [
                    {
                        rotation: require('@/assets/images/travel/hainan01.png'),
                        day: 5,
                        per_price: 3999,
                        title: '5日三亚·带娃泡五星酒店+打卡天涯海角+畅玩亚特兰蒂斯',
                        content: '海天一色，一家同行'
                    },
                    {
                        rotation: require('@/assets/images/travel/hainan02.png'),
                        day: 4,
                        per_price: 4676,
                        title: '4日三亚+三沙·长乐公主号探访西沙群岛',
                        content: '西沙群岛一半珊瑚一半鱼'
                    },
                    {
                        rotation: require('@/assets/images/travel/hainan03.png'),
                        day: 4,
                        per_price: 3700,
                        title: '4日海口+三亚+陵水·椰田古寨+分界洲岛+亚龙湾海底世界',
                        content: '畅玩海南，乐翻天'
                    }
                ],

                dataFourList: [
                    {
                        rotation: require('@/assets/images/travel/shanxi01.png'),
                        day: 6,
                        per_price: 1688,
                        title: '6日-西安+黄陵+宜川+延安+扶风·壶口瀑布黄河情+一生一次窑洞情',
                        content: '寻周秦汉唐，访革命圣地'
                    },
                    {
                        rotation: require('@/assets/images/travel/shanxi02.png'),
                        day: 3,
                        per_price: 1388,
                        title: '3日西安+黄陵+宜川+延安·古城蜜月游+壶口瀑布空中游览+华山之顶同心锁',
                        content: '古城也浪漫'
                    },
                    {
                        rotation: require('@/assets/images/travel/shanxi03.png'),
                        day: 5,
                        per_price: 650,
                        title: '5日西安+咸阳·观历史+赏美食+体味陕西文化之旅',
                        content: '去这座古都，孩子爱上历史'
                    },
                    {
                        rotation: require('@/assets/images/travel/shanxi04.png'),
                        day: 2,
                        per_price: 669,
                        title: '2日宜川+延安+黄陵·观黄河金瀑+飞跃圣地忆苦思甜',
                        content: '回忆那些年的青葱岁月'
                    }
                ],

                dataFiveList: [
                    {
                        rotation: require('@/assets/images/travel/hunan01.png'),
                        day: 3,
                        per_price: 1688,
                        title: '3日凤凰+张家界·烟雨凤凰城+矮寨奇观+十八洞村+香薰山谷定制游',
                        content: '等一城烟雨  ，只为你'
                    },
                    {
                        rotation: require('@/assets/images/travel/hunan02.png'),
                        day: 3,
                        per_price: 1388,
                        title: '3日郴州+资兴·【梦幻郴州】雾漫小东江+网红高椅岭+仰天湖大草原+网红高奢民宿',
                        content: '无浪漫，不郴州'
                    },
                    {
                        rotation: require('@/assets/images/travel/hunan03.png'),
                        day: 5,
                        per_price: 650,
                        title: '5日张家界+凤凰+永顺·乘百龙天梯观石海峰林+划着轻舟赏千年凤凰',
                        content: '屹立于北纬30°的天门山'
                    },
                    {
                        rotation: require('@/assets/images/travel/hunan04.png'),
                        day: 2,
                        per_price: 669,
                        title: '2日长沙+张家界·享星城美食+观张家界奇峰秀水',
                        content: '享长沙美食，观张家界奇峰'
                    }
                ],

                jingdianList: [
                    {
                        text: '景点案例'
                    },
                    {
                        text: '研学游学'
                    },
                    {
                        text: '美食购物'
                    },
                    {
                        text: '亲子旅行'
                    },
                ],
                jingdianNum: 0,

                typeDataList: [],
                /*typeDataListOne: [
                    {
                        img: require('@/assets/images/travel/jdan01.png'),
                        day: 5,
                        money: 2980,
                        title: '5日重庆+成都·川渝双城记品地道川味+洪崖洞网红景点打卡'
                    },
                    {
                        img: require('@/assets/images/travel/jdan02.png'),
                        day: 5,
                        money: 3500,
                        title: '5日成都+乐山+峨眉山·家庭亲子+品成都美味+感受川蜀文化'
                    },
                    {
                        img: require('@/assets/images/travel/jdan03.png'),
                        day: 5,
                        money: 2960,
                        title: '5日桂林+灵川+阳朔·赏龙脊梯田+打卡网红银子岩+山水实景印象刘三姐'
                    },
                    {
                        img: require('@/assets/images/travel/jdan04.png'),
                        day: 10,
                        money: 7880,
                        title: '10日乌鲁木齐+库尔勒+巴音郭楞+库车+轮台·穿越沙漠公路+观千年不倒胡杨林+体验南疆民俗文化'
                    },
                    {
                        img: require('@/assets/images/travel/jdan05.png'),
                        day: 4,
                        money: 1638,
                        title: '4日厦门·亲子旅拍+帆船出海+烂漫沙滩大海+滋味特色美食'
                    }
                ],*/

                /*typeDataListTwo: [
                    {
                        img: require('@/assets/images/travel/yunnan01.png'),
                        day: 6,
                        money: 2300,
                        title: '6日丽江+大理+香格里拉·敞篷吉普车环游洱海+探访神秘女儿国+篝火晚会'
                    },
                    {
                        img: require('@/assets/images/travel/yunnan02.png'),
                        day: 5,
                        money: 2480,
                        title: '5日西双版纳·傣乡雨林探秘+观大象表演孔雀放飞'
                    },
                    {
                        img: require('@/assets/images/travel/yunnan03.png'),
                        day: 5,
                        money: 1880,
                        title: '5日丽江+大理·蜜月之旅+夜宿双廊海景房+观巍峨玉龙雪山'
                    },
                    {
                        img: require('@/assets/images/travel/yunnan04.png'),
                        day: 6,
                        money: 2180,
                        title: '6日大理+丽江+香格里拉·洱海旅拍+登顶雪山+探索世外桃源'
                    },
                    {
                        img: require('@/assets/images/travel/jdan05.png'),
                        day: 4,
                        money: 1638,
                        title: '4日厦门·亲子旅拍+帆船出海+烂漫沙滩大海+滋味特色美食'
                    }
                ],*/

                /*typeDataListThree: [
                    {
                        img: require('@/assets/images/travel/jdan01.png'),
                        day: 5,
                        money: 2980,
                        title: '5日重庆+成都·川渝双城记品地道川味+洪崖洞网红景点打卡'
                    },
                    {
                        img: require('@/assets/images/travel/jdan02.png'),
                        day: 5,
                        money: 3500,
                        title: '5日成都+乐山+峨眉山·家庭亲子+品成都美味+感受川蜀文化'
                    },
                    {
                        img: require('@/assets/images/travel/jdan03.png'),
                        day: 5,
                        money: 2960,
                        title: '5日桂林+灵川+阳朔·赏龙脊梯田+打卡网红银子岩+山水实景印象刘三姐'
                    },
                    {
                        img: require('@/assets/images/travel/jdan04.png'),
                        day: 10,
                        money: 7880,
                        title: '10日乌鲁木齐+库尔勒+巴音郭楞+库车+轮台·穿越沙漠公路+观千年不倒胡杨林+体验南疆民俗文化'
                    },
                    {
                        img: require('@/assets/images/travel/jdan05.png'),
                        day: 4,
                        money: 1638,
                        title: '4日厦门·亲子旅拍+帆船出海+烂漫沙滩大海+滋味特色美食'
                    }
                ],*/

                /*typeDataListFour: [
                    {
                        img: require('@/assets/images/travel/yunnan01.png'),
                        day: 6,
                        money: 2300,
                        title: '6日丽江+大理+香格里拉·敞篷吉普车环游洱海+探访神秘女儿国+篝火晚会'
                    },
                    {
                        img: require('@/assets/images/travel/yunnan02.png'),
                        day: 5,
                        money: 2480,
                        title: '5日西双版纳·傣乡雨林探秘+观大象表演孔雀放飞'
                    },
                    {
                        img: require('@/assets/images/travel/yunnan03.png'),
                        day: 5,
                        money: 1880,
                        title: '5日丽江+大理·蜜月之旅+夜宿双廊海景房+观巍峨玉龙雪山'
                    },
                    {
                        img: require('@/assets/images/travel/yunnan04.png'),
                        day: 6,
                        money: 2180,
                        title: '6日大理+丽江+香格里拉·洱海旅拍+登顶雪山+探索世外桃源'
                    },
                    {
                        img: require('@/assets/images/travel/jdan05.png'),
                        day: 4,
                        money: 1638,
                        title: '4日厦门·亲子旅拍+帆船出海+烂漫沙滩大海+滋味特色美食'
                    }
                ],*/

                tjList: [
                    {
                        text: '团队建设'
                    },
                    {
                        text: '自然村野'
                    },
                    {
                        text: '乡村振兴'
                    },
                    {
                        text: '民俗文化'
                    },
                ],
                tjListNum: 0,

                tjDataList: [],
                tjDataListOne: [
                    {
                        img: require('@/assets/images/travel/jdan01.png'),
                        day: 5,
                        money: 2980,
                        title: '5日重庆+成都·川渝双城记品地道川味+洪崖洞网红景点打卡'
                    },
                    {
                        img: require('@/assets/images/travel/jdan02.png'),
                        day: 5,
                        money: 3500,
                        title: '5日成都+乐山+峨眉山·家庭亲子+品成都美味+感受川蜀文化'
                    },
                    {
                        img: require('@/assets/images/travel/jdan03.png'),
                        day: 5,
                        money: 2960,
                        title: '5日桂林+灵川+阳朔·赏龙脊梯田+打卡网红银子岩+山水实景印象刘三姐'
                    }
                ],

                hoveShow: false,
                showNum: -1,

                giveList: [
                    {
                        img: require('@/assets/images/travel/icon01.png'),
                        text1: '拒绝程式化',
                        text2: '根据你的喜好随心定制你的行程'
                    },
                    {
                        img: require('@/assets/images/travel/icon02.png'),
                        text1: '6000+专业定制师',
                        text2: '更多高性价比旅行资源'
                    },
                    {
                        img: require('@/assets/images/travel/icon03.png'),
                        text1: '免费制作行程方案',
                        text2: '给你自由行的安全感'
                    },
                    {
                        img: require('@/assets/images/travel/icon04.png'),
                        text1: '一站式服务',
                        text2: '省去做攻略、预订资源的繁琐流程'
                    }
                ],

                showWx: false
            }
        },
        mounted: function () {
            this.startCity = this.getcityName;
            this.getCityData();
            this.getTravelData(1);
            // this.dataProList = this.dataOneList;
            // this.typeDataList = this.typeDataListOne;
            this.tjDataList = this.tjDataListOne;
        },
        methods: {
            typeChange(idx) {
                this.curNum = idx;
            },
            showBz() {
                this.showBox = true;
            },
            closeBox() {
                this.showBox = false;
            },
            tabLiClick(idx) {
                this.tabOne = idx;
            },
            proClick(idx) {
                this.proNum = idx;
                if (idx == 0) {
                    // this.dataProList = this.dataOneList;
                    this.getTravelData(1);
                } else if (idx == 1) {
                    // this.dataProList = this.dataTwoList;
                    this.getTravelData(2);
                } else if (idx == 2) {
                    // this.dataProList = this.dataThreeList;
                } else if (idx == 3) {
                    // this.dataProList = this.dataFourList;
                } else if (idx == 4) {
                    // this.dataProList = this.dataFiveList;
                }

            },
            jingdianClick(idx) {
                this.jingdianNum = idx;
                if (idx == 0) {
                    this.typeDataList = this.typeDataListOne;
                } else if (idx == 1) {
                    this.typeDataList = this.typeDataListTwo;
                } else if (idx == 2) {
                    this.typeDataList = this.typeDataListThree;
                } else if (idx == 3) {
                    this.typeDataList = this.typeDataListFour;
                }
            },

            tjClick(idx) {
                this.tjListNum = idx;

                if (idx == 0) {
                    this.tjDataList = this.tjDataListOne;
                } else if (idx == 1) {
                    this.tjDataList = this.tjDataListTwo;
                } else if (idx == 2) {
                    this.tjDataList = this.tjDataListThree;
                } else if (idx == 3) {
                    this.tjDataList = this.tjDataListFour;
                }
            },
            getCityData() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    // console.log(res.data)
                    if (res.status == 200) {
                        that.options = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            todetail(idx, id) {
                // this.$router.push({path: '/travelDetail',query: {id: id}});
                var cidgid = idx + "_" + id;
                this.$router.push({name: "TravelDetail", params: {cidgid: cidgid + ".html"}});
            },

            showCon(a) {
                // console.log(a);
                this.showNum = a;
                // event.target.parentElement.querySelector(".env-del-btn-span").style.cssText += "display:block"
            },

            hideCon(a) {
                // console.log(a);
                this.showNum = -1;
            },

            getTravelData(isFj) { // isFj：1 福建数据，isFj：2 非福建数据
                var travel_type = ''; //个人定制 团建
                var city = '';
                var province = '';
                this.$axios.post('http://vvv.baostart.com/api/travelList', {
                    /*travel_type: travel_type,
                    city: city,
                    province: province*/
                    is_fj: isFj
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        res.data.forEach((item) => {
                            item.per_price = item.per_price.split('.')[0];
                        })
                        this.dataProList = res.data;
                        this.typeDataList = res.data;
                    }
                }).catch((err) => {
                    console.log(err)
                });
            },

            handleChangeT(value) {
                console.log(value)
                var that = this;
                var cityName;
                var cityId;
                var provinceName;

                /*if (value[0] == '110000' || value[0] == '120000' || value[0] == '310000' || value[0] == '500000') {
                    cityName = CodeToText[value[0]];
                } else {
                    cityName = CodeToText[value[1]];
                    provinceName = CodeToText[value[0]];
                }*/
                provinceName = value[0];
                cityName = value[1];
                this.startCity = cityName;
            },

            // 城市选择弹窗
            showCityBoxBtn() {
                if (this.showCityBox) {
                    this.showCityBox = false;
                } else {
                    this.showCityBox = true;
                }
            },

            closeCity() {
                this.showCityBox = false;
            },

            curclickBtn(idx) {
                this.curClick = idx;
            },

            // 热门-热门目的地
            hotCityClick(idx) {
                // this.hotCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 周边-热门目的地
            nearCityClick(idx) {
                // this.nearCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 周边-江苏
            jiangsuCityClick(idx) {
                // this.jiangsuCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 周边-浙江
            zhejiangCityClick(idx) {
                // this.zhejiangCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 周边-上海
            shanghaiCityClick(idx) {
                // this.shanghaiCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 境内热门目的地
            hotInCityClick(idx) {
                // this.hotInCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 安徽
            hotInAnHuiCityClick(idx) {
                // this.hotInAnHuiCityNum = idx;
                let arrIndex = this.spanIndex.indexOf(idx.id);
                this.overNum(arrIndex, idx);
            },

            // 判断是否超过5个城市
            overNum(arrIndex, idx) {
                if (arrIndex > -1) {
                    this.spanIndex.splice(arrIndex, 1);
                    this.spanText.splice(arrIndex, 1);
                    /*console.log(this.spanIndex);
                    console.log(this.spanText);*/
                    this.itemList = '';
                    if (this.spanText.length) {
                        this.spanText.forEach((item) => {
                            this.itemList = this.itemList + item + ",";
                        })
                        this.endCity = this.itemList.substr(0, this.itemList.length - 1);
                    } else {
                        this.endCity = '';
                    }
                } else {
                    if (this.spanIndex.length >= 5) {
                        this.$message('最多可选5个目的地');
                    } else {
                        this.spanIndex.push(idx.id);
                        this.spanText.push(idx.text);
                        /*console.log(this.spanIndex);
                        console.log(this.spanText);*/

                        this.itemList = '';
                        if (this.spanText.length) {
                            this.spanText.forEach((item) => {
                                this.itemList = this.itemList + item + ",";
                            })
                            this.endCity = this.itemList.substr(0, this.itemList.length - 1);
                        } else {
                            this.endCity = '';
                        }
                    }
                }
            },
            submitPost() {
                var startCity = this.startCity;
                var endCity = this.endCity;
                var timeStart = this.timeStart;
                var personNum = this.personNum;
                var formTelephone = this.formTelephone;

                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

                if (startCity == '' || startCity == undefined || startCity.length <= 0) {
                    this.$message('请选择出发城市');
                    return;
                }

                if (endCity == '' || endCity == undefined || endCity.length <= 0) {
                    this.$message('请选择目的城市');
                    return;
                }

                if (timeStart == '' || timeStart == undefined || timeStart.length <= 0) {
                    this.$message('请选择出发时间');
                    return;
                }

                if (personNum == '' || personNum == undefined || personNum.length <= 0) {
                    this.$message('请输入乘车人数');
                    return;
                }

                if (!myreg.test(formTelephone)) {
                    this.$message('请输入正确的手机号码');
                    return;
                }

                this.$axios.post('http://vvv.baostart.com/api/trivel_message', {
                    source: 'pc端留言',
                    mobile: formTelephone,
                    start_city: startCity,
                    end_city: endCity,
                    url: '',
                    username: '',
                    start_date: timeStart,
                    people_num: personNum,
                    message_type: ''
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        console.log(res.data);
                        this.$message('提交成功！请耐心等待回电');
                        this.endCity = '';
                        this.spanIndex = [];
                        this.spanText = [];
                        this.itemList = '';
                        this.personNum = '';
                        this.formTelephone = '';
                    }
                }).catch((err) => {
                    console.log(err)
                });
            },

            toTop(){
                let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
                let step = distance / 30; //每步的距离
                (function jump() {
                    if (distance > 0) {
                        distance -= step;
                        window.scrollTo(0, distance);
                        setTimeout(jump, 10);
                    }
                })();
            },

            showWhatChat() {
                this.showWx = true;
            },
            hideWhatChat() {
                this.showWx = false;
            }
        },
        computed: {
            ...mapGetters(['getcityName']),
            userName() {
                return this.$store.state.userName;
            },
        },
    }
</script>

<style scoped>
    @import './travel.css';
</style>



// WEBPACK FOOTER //
// src/pages/travel/travel.vue